
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * メッセージ画面から一覧に戻るボタン
 */
@Component({
  components: {
    ButtonBase,
    PanelFrame,
  },
})
export default class NoticeMessageLinkPanel extends Vue {
  /** クリック時のイベント */
  @Prop()
  private clickEvent!: () => void
}
